import {useTranslation} from 'react-i18next'
import {KTSVG} from '../../../_metronic/helpers'
import {memo} from 'react'
import {useRoleUser} from '../../../hooks/useRoleUser'
import dateformat from 'src/utils/dateformat'
import {ActionIcon} from 'src/components'

interface IData {
  id: number
  lang?: string
  module?: string
  sales_org?: {
    name?: string
  }
  sales_org_code?: string
  content?: string
  other?: string
  footer?: string
  created_at?: string
  updated_at?: string
}

export interface RowDataProps {
  rowNumber: number
  data: IData
  onEdit: (data: IData) => void
  onDelete: (data: IData) => void
}

export const RowData = memo((props: RowDataProps) => {
  const {rowNumber, data, onEdit, onDelete} = props
  const {t} = useTranslation()
  const roleUser = useRoleUser()

  return (
    <tr>
      <td>{rowNumber}</td>
      {!roleUser.isSalesAnper && <td>{data?.sales_org?.name ?? '-'}</td>}
      <td>{data?.lang}</td>
      <td>{t(data?.module ?? '-')}</td>
      <td>{dateformat(data?.created_at as string)}</td>
      <td>{dateformat(data?.updated_at as string)}</td>
      <td>
        <ActionIcon
          className='me-2'
          title={t('Edit')}
          iconPath='/media/icons/duotune/pencil-fill.svg'
          onClick={() => onEdit(data)}
        />
        <button
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
          title={t('Hapus')}
          onClick={() => onDelete(data)}
        >
          <KTSVG path='/media/icons/duotune/trash-fill.svg' className='svg-icon-3' />
        </button>
      </td>
    </tr>
  )
})
